"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        var taskGuide;
        (function (taskGuide) {
            /**
             * Used in the task guide chain to position the blocking divs around the Task Guide tooltip target.
             * is obscured by another element (such as a lookup opening over the target).
             */
            var LayoutUpdateHandlingComponent = /** @class */ (function () {
                function LayoutUpdateHandlingComponent(controller) {
                    var _this = this;
                    this.controller = controller;
                    this.dispose = function () {
                        var e_1, _a;
                        try {
                            for (var _b = __values(_this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var subscription = _c.value;
                                if (subscription && subscription.dispose) {
                                    subscription.dispose();
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _this.subscriptions = null;
                        $(document).off("flyoutRemoved", _this.flyoutRemovedHandler);
                        $dyn.shell.shellReflowEvent().unsubscribe(_this.shellReflowSubscriberId);
                    };
                    this.flyoutRemovedHandler = function () {
                        if (_this.guidedStep) {
                            _this.deferHandleLayoutUpdates(400);
                        }
                    };
                    this.onShellReflow = function () {
                        _this._hasShellReflowed = true;
                    };
                    this.subscriptions = [];
                    this._isCurrentlyInErrorState = false;
                    this.guidedStep = null;
                    this._hasShellReflowed = false;
                    this.shellReflowSubscriberId = $dyn.shell.shellReflowEvent().subscribe(this.onShellReflow);
                    this.subscriptions.push($dyn.observe($dyn.ui.layout, function (isLayoutUpdating) {
                        if (!isLayoutUpdating && _this.guidedStep) {
                            _this.deferHandleLayoutUpdates(400);
                        }
                    }));
                    $(document).on("flyoutRemoved", this.flyoutRemovedHandler);
                }
                LayoutUpdateHandlingComponent.prototype.setup = function (input, output) {
                    var _this = this;
                    this.input = input;
                    this.output = output;
                    this.subscriptions.push($dyn.observe(input, function (guidedStep) {
                        _this.guidedStep = guidedStep;
                        _this.inputChanged = true;
                        if (_this._evaluateErrorStateTimer === undefined) {
                            _this.deferHandleLayoutUpdates(0);
                        }
                    }));
                };
                /** @param timeout Deferred length in ms. */
                LayoutUpdateHandlingComponent.prototype.deferHandleLayoutUpdates = function (timeout) {
                    var _this = this;
                    if (this._evaluateErrorStateTimer !== undefined) {
                        this.controller.clearTimeout(this._evaluateErrorStateTimer);
                        this._evaluateErrorStateTimer = undefined;
                    }
                    if (this._evaluateErrorStateTimer === undefined) {
                        this._evaluateErrorStateTimer = this.controller.setTimeout(function () {
                            _this._evaluateErrorStateTimer = undefined;
                            _this.handleLayoutUpdates();
                        }, timeout);
                    }
                };
                LayoutUpdateHandlingComponent.prototype.handleLayoutUpdates = function () {
                    var guidedStep = this.guidedStep;
                    var inputChanged = this.inputChanged;
                    this.inputChanged = false;
                    if (!guidedStep) {
                        return;
                    }
                    if (guidedStep && guidedStep.options && !this._targetIsAccessible(guidedStep.options.target, guidedStep.options.shadowTarget)) {
                        // new state is InError=> only generate new output if previous state was Not inError or if input changed
                        if (!this._isCurrentlyInErrorState || inputChanged || this._hasShellReflowed) {
                            var clonedStep = $.extend({}, guidedStep);
                            clonedStep.options = $.extend({}, clonedStep.options, {
                                shadowTarget: null,
                                target: null
                            });
                            this._isCurrentlyInErrorState = true;
                            this.output(clonedStep);
                        }
                    }
                    else if (this._isCurrentlyInErrorState || inputChanged || this._hasShellReflowed) {
                        // new state is NoError=> only generate new output if previous state was inError or if input changed or if shell has reflowed
                        this._isCurrentlyInErrorState = false;
                        this._hasShellReflowed = false;
                        this.output(guidedStep, true);
                    }
                };
                LayoutUpdateHandlingComponent.prototype._targetIsAccessible = function (target, shadow) {
                    // target and shadow ideally should be JQuery object, $ is kept for back compatibility if JQuery is not send
                    target = target && $(target);
                    shadow = shadow && $(shadow);
                    if (!target || !target[0] || !target[0].offsetWidth || !target[0].offsetHeight) {
                        return false;
                    }
                    var targetElement;
                    if (shadow && shadow[0]) {
                        targetElement = shadow;
                    }
                    else {
                        targetElement = target;
                    }
                    var elementOffset = targetElement.offset();
                    var elementTopOffset = elementOffset.top;
                    var elementLeftOffset = elementOffset.left;
                    var elementBottomOffset = elementTopOffset + targetElement.height();
                    var elementRightOffset = elementLeftOffset + targetElement.width();
                    if (this._elementFromPointMatchesTarget(target[0], elementLeftOffset + 1, elementTopOffset + 1) ||
                        this._elementFromPointMatchesTarget(target[0], elementRightOffset - 1, elementTopOffset + 1) ||
                        this._elementFromPointMatchesTarget(target[0], elementRightOffset - 1, elementBottomOffset - 1) ||
                        this._elementFromPointMatchesTarget(target[0], elementLeftOffset + 1, elementBottomOffset - 1)) {
                        return true;
                    }
                    return false;
                };
                LayoutUpdateHandlingComponent.prototype._getElementFromPoint = function (x, y) {
                    if (!document.elementFromPoint(x, y)) {
                        return null;
                    }
                    return document.elementFromPoint(x, y);
                };
                LayoutUpdateHandlingComponent.prototype._elementExistsInHierachy = function (hierachy, element) {
                    var parent = hierachy;
                    while (parent) {
                        if (parent === element) {
                            return true;
                        }
                        parent = parent.parentNode;
                    }
                    return false;
                };
                LayoutUpdateHandlingComponent.prototype._elementFromPointMatchesTarget = function (target, x, y) {
                    var elementAtPoint = this._getElementFromPoint(x, y);
                    if (elementAtPoint && $(elementAtPoint) && $(elementAtPoint).closest(".taskGuide-ignoreObscurityError") && $(elementAtPoint).closest(".taskGuide-ignoreObscurityError")[0]) {
                        return true;
                    }
                    if (this._elementExistsInHierachy(target, elementAtPoint) || this._elementExistsInHierachy(elementAtPoint, target)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                return LayoutUpdateHandlingComponent;
            }());
            taskGuide.LayoutUpdateHandlingComponent = LayoutUpdateHandlingComponent;
        })(taskGuide = ax.taskGuide || (ax.taskGuide = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=LayoutUpdateHandlingComponent.js.map
